import React from 'react';
import { IconType } from 'components/Icon/constants';
import EditorToolbarButton from '../EditorToolbarButton';

type Props = {
  isNoWrapActive: boolean;
  onToggle: () => void;
  disabled?: boolean;
  dataTestId?: string;
};

const WrapControl: React.FunctionComponent<Props> = ({ isNoWrapActive, onToggle, disabled, dataTestId = 'wrapControl' }) => (
  <EditorToolbarButton
    active={isNoWrapActive}
    disabled={disabled}
    label={IconType.NO_WRAP}
    onToggle={onToggle}
    value={''}
    title={'NoWrap'}
    dataTestId={`${dataTestId}-editorToolbarButton`}
  />
);

export default WrapControl;
